<template>
    <div class="dashboard"
    :style="{
        'background':`url(../../img/bet/background-${colors.theme}.png), linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
    }">
        <header-default></header-default>
        <!-- <info-default
            :smallTitle="$t('views.dashboard.smallTitle')"
            :title="$t('views.dashboard.title')"
            :textButton="$t('views.dashboard.textButton')"
            actionName="reportGo"> 
        </info-default> -->
        <div class="dashboard-content">
            <div class="title-info">
                <span class="small-title" :style='{  color : "#fff", background: colors.theme == "dark" ? colors [colors.theme].to : "#000" }'>{{$t('views.dashboard.smallTitle')}}</span>
                <span class="title" :style="{ color: colors.theme == 'dark' ? '#fff' : '#000' }">{{$t('views.dashboard.title')}}</span>
                <span class="shadow" :style='{ color : colors.theme == "dark" ? "#fff" : "#000"}'>{{$t('views.dashboard.title')}}</span>

            </div>
            <div class="desc-info">
                <div class="final_score_value">
                    <h1 :style='{color: colors.theme == "dark" ? "#fff" : "#000"}'>{{this.$t("views.finalScore.visualFeedback.title")}}</h1>
                    <Coin class="coin" :fill='colors.theme == "dark" ? colors.primary : "#000"'></Coin>
                    <!-- <span class="score_value" :style='{color: colors.theme == "dark" ? colors.primary : "#000"}'>54.000</span> -->
                    <span class="score_value" :style='{color: colors.theme == "dark" ? colors.primary : "#000"}'>{{(score).toLocaleString("pt-br")}}</span>
                </div>   
                <span class="desc" :style="{ color: colors.theme == 'dark' ? '#fff' : '#000' }">{{$t('views.dashboard.desc')}} {{Boolean(!hasFeedback) ? $t('views.dashboard.feedback') : ""}} :)</span>
            </div>    
            <div class="button" @click="goReport()">
                <button-default :textButton="reportButtonText" buttonType="primary"></button-default>    
                <div class="arrow-right"></div>
            </div>              
            <!-- <div class="button button-feedback" v-if="Boolean(!hasFeedback)" @click="goFeedback()"> -->
            <div class="button button-feedback" @click="goFeedback()">
                <button
                :style="{ 
                    color: colors.theme == 'dark' ? '#fff' : '#000',
                    'background' : 'none',
                    'border': colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000',
                    'border-bottom' : colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000'
                }">{{$t('views.dashboard.textButton2')}}</button>    
            </div>              
        </div>               
    </div>
</template>
<script>
import { Bus } from '../../event-bus.js'
import HeaderDefault from '../../components/shared/header/Navbar'
import InfoDefault from '../../components/shared/default/InfoDefault'
import Coin from "../../components/shared/customIcons/ExtractCoin"
import ButtonDefault from "../../components/buttons/ButtonDefault.vue";
export default {
    components : {
        HeaderDefault,
        InfoDefault,
        Coin,
        ButtonDefault
    },
    data: function(){
        return{
            colors:{},
            score: 0,
            hasFeedback: false,
            reportButtonText: this.$t('views.dashboard.textButton')
        }
    },
    created(){
        Bus.$on('reportGo', this.goReport)
        this.colors = JSON.parse(localStorage.getItem("colors"));
        this.hasFeedback = localStorage.getItem("feedback")
        this.getScore()
    },
    destroyed(){
        Bus.$off('reportGo')
    },
    methods: {
        goReport(){
            this.$router.push({path:'/report/generate'})
        },
        goFeedback(){
            this.$router.push({path:'/feedback'})
        },
        async getScore(){
            try {
                const { data: scoreReq } = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/${localStorage.getItem("gameSetId")}/calc-score`)
                this.score = scoreReq.score
            } catch (error) {
                // console.error("Error trying to get SCORE: ", error)
                alert("Erro ao calcular seu score: ", error)
            }
        }
    }
  }
</script>
<style lang="scss" >
.dashboard{
    background-size: cover !important;
    height: 100%;

    .dashboard-content{
        height: calc(100% - 55px);
        display: flex;
        flex-direction: column;
        align-items: center;
        // margin: 40% auto;
        justify-content: center;

            .desc{
                text-align: center;
                padding: 32px;
                display: flex;
            }
            .desc-info{
                padding: 0 150px;
            }

            .final_score_value{
            display: flex;
            width: 100%;
            justify-content: center;      
            // margin-bottom: 32px;
            // margin-top: -32px;
            font-size: 23px;
            font-weight: 700;
            align-items: center;
        
                .coin{
                    width: 40px;
                    height: 40px;
                    padding: 0 12px;
                }

                span{
                    font-size: 36px;
                }
            }  

        .title-info {
          height: 150px;
          display: flex;
          flex-direction: column;
          text-align: center;
          text-transform: uppercase;
          // line-height: 20px;
          letter-spacing: 0px;
          font-size: 50px;
          align-items: center;
    
    
          .small-title {
            text-transform: uppercase;
            font-weight: 600;
            letter-spacing: 4px;
            font-size: 17px;
            border-radius: 300px;
            padding: 5px 32px;    
            margin: 32px 0 20px;
            max-width: 310px;
          }
    
          .title {
            font-weight: 900;
            line-height: 40px;
          }
            .shadow{
                -webkit-text-fill-color: transparent;
                -webkit-text-stroke-width: 1px;
                // -webkit-text-stroke-color: white;
                position: relative;
                top: -44px;
                left: 2px;
                font-weight: 900;
            }    
              
        } 
        .button {
          width: 80%;
          margin: 10px auto;
          display: flex;
          flex-direction: row;
          align-items: center;
          max-width: 300px;

          button{
                height: 55px;
                border-radius: 300px;
                font-size: 15px;
                padding: 20px;
                padding-bottom: 15px !important;
          }
    
          .arrow-right {
            height: 0;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-left: 6px solid #fff;
            width: 0;
            position: relative;
            right: 33px;
          }      
        }
        .button-feedback{
            height: 40px;
            border: none;
            font-weight: bold;
            font-size: 30px;
            outline: none;
            letter-spacing: 2px;
            cursor: pointer;
            text-transform: uppercase;
            border-radius: 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;    
            
            button{
                width: 100%;
                font-weight: 900;
                text-transform: uppercase;
                font-size: 15px;
                padding: 20px;
            }
        }
    }
}

@media only screen and (max-width: 700px){
    .dashboard .dashboard-content .desc-info{
        padding: 0 15px;
    }
}
</style>
